import { component } from 'picoapp';
import { on } from '@selfaware/martha';
import inview from '@/util/inview';

export default component((node, ctx) => {
  // additional marquee functionality
});
